import axios from 'axios';
import { Modal } from 'antd';

// export const BaseUrl="http://192.168.1.136:8001/api/"
// export const BaseUrl = "https://out-politics-phase-tablets.trycloudflare.com/api/"

//testing
//export const BaseUrl="http://3.13.249.184/api/"

//live
export const BaseUrl="https://employpro.employprotech.com/api/"

export const LoginUrl = BaseUrl+ "user/login"
export const MeUrl = BaseUrl + "user/Me"
export const CreateUserUrl = BaseUrl + "user/create-user"
export const UsersUrl = BaseUrl + "user/users"
export const UpdatePasswordUrl = BaseUrl + "user/update-password"
export const ForgotPasswordUrl = BaseUrl + "user/ForgotPasswordView"
export const ResetPasswordUrl = BaseUrl + "user/ResetPasswordView"
export const VerifyTokenUrl = BaseUrl + "user/verify-token"
export const SupportUrl = BaseUrl + "user/support"
// Case Management URLs (Legacy - to be removed)
export const CasesUrl = BaseUrl + "masterdata/cases/"
export const CaseStatisticsUrl = BaseUrl + "masterdata/case-details/statistics/"
export const CaseOutcomeAnalyticsUrl = BaseUrl + "masterdata/cases/outcome_analytics/"
export const QLetterCasesUrl = BaseUrl + "masterdata/cases/q_letter_cases/"
export const InfoForLetterCasesUrl = BaseUrl + "masterdata/cases/info_for_letter_cases/"

// New Case Management URLs
export const CaseNumbersUrl = BaseUrl + "masterdata/case-numbers/"
export const CaseDetailsUrl = BaseUrl + "masterdata/case-details/"

// Scoring Questions URLs
export const CaseScoringQuestionsUrl = BaseUrl + "masterdata/case-scoring-questions/"
export const CategoryWeightagesUrl = BaseUrl + "masterdata/category-weightages/"
export const LikelihoodScoresUrl = BaseUrl + "masterdata/likelihood-scores/"

// References URLs
export const ReferencesUrl = BaseUrl + "masterdata/references/"

// Stripe URLs
export const AdminSubscriptionsUrl = BaseUrl + "stripe/admin/subscriptions"
export const CancelSubscriptionUrl = BaseUrl + "stripe/cancel-subscription"
export const UserSubscriptionSettingsUrl = BaseUrl + "stripe/subscription-settings"
export const StripeSignupCheckoutUrl = BaseUrl + "stripe/signup-checkout"
export const ReactivateCheckoutUrl = BaseUrl + "stripe/reactivate-checkout"
export const CreatePortalSessionUrl = BaseUrl + "stripe/create-portal-session"

let activeErrorModal: any = null;

export const extractErrorMessage = (error: any): string | null => {
  if (!error) return null;
  const data = error.response?.data;
  if (data) {
    if (typeof data === 'string') return data;
    if (data.error && typeof data.error === 'string') return data.error;
    if (data.detail && typeof data.detail === 'string') return data.detail;
    if (data.message && typeof data.message === 'string') return data.message;
    if (typeof data === 'object') {
      const keys = Object.keys(data);
      if (keys.length > 0) {
        const firstVal = data[keys[0]];
        if (Array.isArray(firstVal) && firstVal.length > 0) {
          return `${keys[0]}: ${firstVal[0]}`;
        }
        if (typeof firstVal === 'string') {
          return `${keys[0]}: ${firstVal}`;
        }
      }
    }
  }
  if (error.message && error.message !== 'Network Error') {
    return error.message;
  }
  return error.message || 'An error occurred while communicating with the server.';
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if (error.config?.skipGlobalErrorModal) {
      return Promise.reject(error);
    }

    const errorMsg = extractErrorMessage(error);

    if (errorMsg && !activeErrorModal) {
      activeErrorModal = Modal.error({
        title: 'Error',
        content: errorMsg,
        centered: true,
        maskClosable: true,
        okText: 'Close',
        okButtonProps: {
          style: {
            backgroundColor: '#4682b4',
            borderColor: '#4682b4',
            borderRadius: '20px',
            fontFamily: "'Lexend', sans-serif",
          },
        },
        onOk: () => {
          activeErrorModal = null;
        },
        onCancel: () => {
          activeErrorModal = null;
        },
      });
    }

    return Promise.reject(error);
  }
);

